__turbopack_context__.v({
  "animatedOverlay": "styles-module__Y3-ToW__animatedOverlay",
  "fadeIn": "styles-module__Y3-ToW__fadeIn",
  "fadeOut": "styles-module__Y3-ToW__fadeOut",
});
